module.exports = __webpack_public_path__ + "static/img/banner_solutions_precision.325e352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_precision.png
// module id = t3g5
// module chunks = 10